module.exports = __webpack_public_path__ + "static/media/teeth.61ca7313.svg";